import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import AdmLoginSignup from "./Components/AdmLoginSignup/AdmLoginSignup";
import Admin from "./Pages/Admin";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./Components/ErrorBoundary/fback";
import { AuthProvider, useAuth } from "./Context/AuthContext";
import LoadingSpinner from "./Components/LoadingSpinner/LoadingSpinner";

export const backend_url = "https://test-fsbackend.onrender.com";
export const auth_url = "https://test-fsbackend.onrender.com/admin";
export const currency = "₹";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner message="Checking authentication..." />;
  }

  return isAuthenticated ? children : <Navigate to="/" />;
};

// Main App Component
function AppContent() {
  return (
    <div>
      <Router>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<AdmLoginSignup />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Admin />
                  </ErrorBoundary>
                </ProtectedRoute>
              }
            />
            <Route path="Footer" element={<Footer />} />
          </Routes>
          <Footer />
        </AuthProvider>
      </Router>
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App;
